import { all, Div, H3, reactive, Span, VArray } from 'alkali'
import Dropdown from 'components/generic/Dropdown'
import { analyzeTreatmentAs, analysisSelections, currentAnalysisSelections, selectedStudies, structuredQuery, } from 'model/SearchQuery'
import { studySearchCache, cumulativeAllTreatments } from 'model/EvidenceSearch'
import  RenameDialog  from './RenameDialog'

export class GroupingManagementDropdown extends Dropdown.with('.grouping-management-dropdown') {
	ready() {
		this.selectedGroupingLabel = reactive('')
		this.connected = reactive('')
		this.selectedGrouping = all([this.selectedGroupingLabel, analysisSelections], (groupingLabel, analysisSelections) => {
			let analyzeAs = analysisSelections.analyzeAs
			return analyzeAs?.find(({ label }) => label == groupingLabel)
		})
		this.items = [
			{
				content: 'Make this the baseline intervention group',
				onclick: () => {
					analysisSelections.baseline.put(this.selectedGroupingLabel.valueOf())
				}
			},
			{
				content: 'Rename this intervention group',
				display: this.selectedGroupingLabel.to(label => label != 'Control'),
				onclick: () => {
					let currentLabel = this.selectedGroupingLabel.valueOf()
					if (currentLabel == 'Control')
						return
					new RenameDialog({ currentLabel }).show()
				}
			},
			{
				content: 'Ungroup this intervention group',
				display: all([this.selectedGroupingLabel, analyzeTreatmentAs], (currentLabel, analyzeTreatmentAs) => {
					if (currentLabel == 'Control')
						return false
					let senseMappings = 0
					for (let [ id, label ] of analyzeTreatmentAs) {
						if (label == currentLabel && id != null && (id + '').startsWith('S'))
							senseMappings++
					}
					return senseMappings != 1
				}),
				onclick: () => {
					let currentLabel = this.selectedGroupingLabel.valueOf()
					for (let [ id, label ] of analyzeTreatmentAs) {
						if (label == currentLabel) {
							let term = cumulativeAllTreatments.get(id)
							analyzeTreatmentAs.ungroup(this.selectedGroupingLabel.valueOf(), term)
						}
					}
					let studySelections = analysisSelections.get('studySelections') || {}
					let selectionsChanged
					for (let id in studySelections) {
						let selections = studySelections[id]
						for (let groupAnalyzeAs of selections.groupAnalyzeAs || []) {
							if (groupAnalyzeAs.analyzeLabel == currentLabel) {
								selections.groupAnalyzeAs.splice(selections.groupAnalyzeAs.indexOf(groupAnalyzeAs), 1)
								selectionsChanged = true
							}
						}
					}
					
					if (selectionsChanged)
						currentAnalysisSelections.studySelections.put(studySelections)
					studySearchCache.clear()
					
				}
			},
			{
				content: this.selectedGrouping.to(grouping => (grouping?.disabled ? 'Enable' : 'Disable') + ' this intervention group for analysis'),
				onclick: () => {
					let grouping = this.selectedGrouping.valueOf()
					if (grouping) {
						grouping.disabled = !grouping.disabled
						analysisSelections.analyzeAs.put(analysisSelections.analyzeAs.valueOf())
					} else {
						let label = this.selectedGroupingLabel.valueOf()
						analysisSelections.analyzeAs.push({
							id: label,
							label,
							disabled: true,
						})
					}
				}
			},
			{
				// only show if network graph is active and has connections
				content: 'Remove this intervention group from analysis',
				display: true,
				onclick: () => {
					let currentLabel = this.selectedGroupingLabel.valueOf()
					analyzeTreatmentAs.removeFromAnalysis(this.selectedGroupingLabel.valueOf())
				}
			},
		]
	}
	setGrouping(groupingLabel) {
		this.selectedGroupingLabel.put(groupingLabel)
	}
	checkConnections(isConnected) {
		// disable if network graph is not shown
		if (selectedStudies.valueOf().length == 0)
			isConnected = false
		this.connected.put(isConnected)
	}
	attached() {
		super.attached()
		if (!this.headerAdded) {
			this.headerAdded = true
			setTimeout(() =>
				this.prepend(H3('.compare-as',[
					'Manage Intervention Groups']))
			)
		}
	}
}
